import {Box, Button, Typography} from "@mui/material";
import React from "react";
import {Projects} from "../../redux/types/firebase";

interface Props {
    onSetMode: (mode: string, project: string) => void
    project: string
    projects: Projects
}
export default function ProjectDetailsViewer({onSetMode, project, projects}: Props) {
    const projectDetails = projects[project];
    const setTop = Boolean(projects[project]?.setTop);
    const handleClickIntertitles = ({currentTarget}: React.MouseEvent<HTMLElement>) => {
        onSetMode("intertitle", currentTarget.dataset.project as string);
    };
    const handleClickPlay = ({currentTarget}: React.MouseEvent<HTMLElement>) => {
        onSetMode("play", currentTarget.dataset.project as string);
    };

    return (
        <Box display="flex" flexDirection="column">
            <Box display="flex">
                <Typography title={projectDetails.description} sx={{flexGrow: 1}} variant="h6">
                    {projectDetails.name}
                </Typography>
                {setTop ?
                    <Button data-project={project} onClick={handleClickPlay} title="Play set top game"
                            variant="contained" sx={{m:1}}>
                        Play
                    </Button> :
                    <Button data-project={project} onClick={handleClickIntertitles} title="Show intertitles"
                            variant="contained" sx={{m:1}}>
                        Intertitles
                    </Button>
                }
                <Button data-project={project} onClick={() => onSetMode("script", project)} title="Show Script"
                        variant="contained" sx={{m:1}}>
                    Script
                </Button>
            </Box>
            <Typography variant="body1">{projectDetails.description}</Typography>
        </Box>
    );
}